import { render, staticRenderFns } from "./compareHealtProtection.vue?vue&type=template&id=19c23538&"
import script from "./compareHealtProtection.vue?vue&type=script&lang=ts&"
export * from "./compareHealtProtection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports